import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { styled } from '@mui/system';

// Wrapper sekcji
const SectionWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',  // by mieć odniesienie dla pseudo-elementu
  backgroundColor: theme.palette.background.default,
  paddingTop: '120px',
  paddingBottom: '0',
  marginBottom: '120px',


  // responsywny pseudo-element na mobile
  [theme.breakpoints.down('sm')]: {
    '&::after': {
      width: '100%',
      height: '80px',
      bottom: '-70px',
      right: 0,
      // backgroundSize i pozostałe właściwości dziedziczą się z powyższego bloku
    },
  },
}));

// Nagłówek z podkreśleniem
const UnderlinedHeading = styled('span')({
  position: 'relative',
  zIndex: 1,
  display: 'inline-block',
  '&::after': {
    content: '""',
    position: 'absolute',
    zIndex: -1,
    right: 0,
    bottom: 0,
    width: '30%',
    height: '30px',
    backgroundImage: 'url(/img/redunderline.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'bottom center',
  },
});

const Section8 = () => {
  return (
    <SectionWrapper component="section" id="section8" sx={{ scrollMarginTop: '100px' }}>
      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid
          container
          spacing={4}
          alignItems="flex-end"
          direction={{ xs: 'column-reverse', md: 'row' }}
        >          {/* Lewa kolumna: obrazek zajmuje 5/12 */}
          <Grid item size={{ xs: 12, md: 5 }} sx={{
            mt: { xs: 0, md: '50px' },
          }}>
            <Box
              component="img"
              src="/img/picture3.png"
              alt="Kontakt Bimetria"
              sx={{ width: '100%', height: 'auto' }}
            />
          </Grid>

          {/* Pusta kolumna przerwy */}
          <Grid item size={{ xs: 0, md: 1 }} />

          {/* Prawa kolumna: dane kontaktowe zajmuje 6/12 */}
          <Grid item size={{ xs: 12, md: 6 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '28px', md: '54px' },
                fontWeight: 'bold',
                color: 'primary.main',
                mb: 3,
                position: 'relative',
                zIndex: 1,
              }}
            >
              <UnderlinedHeading>Kontakt</UnderlinedHeading>
            </Typography>

            {/* Akapit opisowy */}
            <Typography
              component="p"
              sx={{ fontSize: '18px', color: 'text.primary', mb: 2, lineHeight: 1.5 }}
            >
              Chcesz dowiedzieć się więcej lub zapytać o wycenę?
              Napisz do nas.

            </Typography>

            {/* Dwie kolumny z danymi i godzinami */}
            <Grid
              container
              spacing={2}
              sx={theme => ({
                position: 'relative',         // potrzebne dla pseudo-elementu
                // paddingBottom: { xs: 0, md: '100px' },

                // '&::after': {
                //   content: '""',
                //   position: 'absolute',
                //   bottom: '8px',
                //   right: 0,
                //   width: '100%',
                //   height: '150px',
                //   backgroundImage: 'url(/img/contactafter.svg)',
                //   backgroundRepeat: 'no-repeat',
                //   backgroundSize: 'cover',
                //   backgroundPosition: 'bottom center',
                //   zIndex: 0,
                //   [theme.breakpoints.down('sm')]: {
                //     display: 'none',          // ukryj na mobile
                //   },
                // },
              })}
            >
              {/* Dane kontaktowe */}
              <Grid item  >
                <Typography
                  component="p"
                  sx={{ fontSize: '18px', color: 'text.primary', mb: 2 }}
                >
                  kontakt@bimetria.com
                </Typography>

                <Typography
                  component="p"
                  sx={{ fontSize: '18px', color: 'text.primary', mb: 2, lineHeight: 1.5 }}
                >

                  <b>Bimetria sp. z o.o.</b><br />
                  ul. Grzybowska 87<br />
                  00-844 Warszawa<br />
                </Typography>
                 <Typography
                  component="p"
                  sx={{ fontSize: '16px', color: 'text.primary', mb: 2, lineHeight: 1.5 }}
                >
                  Sąd Rejonowy dla m.st. Warszawy w Warszawie, XIII Wydział Gospodarczy Krajowego Rejestru Sądowego |
                  KRS: 0001217065 | Kapitał zakładowy: 5 000,00 zł
                  <br />
                  <br />
                </Typography>
              </Grid>
              

            </Grid>
          </Grid>
        </Grid>
      </Container>
    </SectionWrapper>
  );


    <Grid item xs={12} md={6} lg={5}>
      <Typography
        component="p"
        sx={{ fontSize: '18px', fontWeight: 'bold', color: 'text.primary', mb: 2 }}
      >
      {/*   Godziny otwarcia: */}
      </Typography>

      {/* kontener na dwie kolumny */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 1.5,
          borderRadius: 1,
        }}
      >
        {/* wiersz 1 */}
        <Typography sx={{ fontSize: '18px', fontWeight: '500' }}> {/* Pon. – Pt. */} </Typography>
        <Typography sx={{ fontSize: '18px' }}> {/* 09:00 – 17:00 */} </Typography>
        {/* wiersz 2 */}
        <Typography sx={{ fontSize: '18px', fontWeight: '500' }}> {/* Sobota */} </Typography>
        <Typography sx={{ fontSize: '18px' }}> {/* 10:00 – 14:00 */} </Typography>
        {/* wiersz 3 */}
        <Typography sx={{ fontSize: '18px', fontWeight: '500' }}> {/* Niedziela */} </Typography>
        <Typography sx={{ fontSize: '18px' }}> {/* zamknięte */} </Typography>
      </Box>
    </Grid>
};

export default Section8;
